import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles/index';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
});
class AlertDialog extends React.Component {
  handleClose = type => {
    this.props.parameters.handleClose(type);
  };

  render() {
    const {
      parameters: { title, message, cancelButtonName, okButtonName },
      classes,
    } = this.props;
    return (
      <div>
        <Dialog
          open
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title || 'Message'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {message.map(ms => <pre>{ms}</pre>)}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {okButtonName && (
              <Button onClick={() => this.handleClose('ok')} className={classes.button}>
                {okButtonName}
              </Button>
            )}
            {cancelButtonName && (
              <Button onClick={() => this.handleClose('cancel')} className={classes.button}>
                {cancelButtonName}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AlertDialog.propTypes = {
  parameters: PropTypes.object,
};
export default withStyles(styles)(AlertDialog);



// WEBPACK FOOTER //
// ./src/components/common/AlertDialog.js